import type { EquationsPrompt } from '../generators/equations.ts'

/**
 * Answer grading for the two text subtests. Pure functions, reused by the
 * Drill feedback (M5); the per-letter detail is what the attempts table's
 * `sub_answers` column will record.
 */

export interface EquationsGrade {
  perLetter: Record<string, boolean>
  allCorrect: boolean
}

/** The item is correct only if ALL letters are right (PLAN.md §2a); per-letter
 * correctness is reported separately for diagnostics. */
export function gradeEquations(
  prompt: EquationsPrompt,
  answerValues: Record<string, number>,
  submitted: Record<string, string>,
): EquationsGrade {
  const perLetter: Record<string, boolean> = {}
  let allCorrect = true
  for (const letter of prompt.letters) {
    const raw = submitted[letter]
    const ok = raw !== undefined && raw !== '' && Number(raw) === answerValues[letter]
    perLetter[letter] = ok
    if (!ok) allCorrect = false
  }
  return { perLetter, allCorrect }
}

export function gradeLatin(answerLetter: string, submitted: string | null): boolean {
  return submitted !== null && submitted === answerLetter
}
